import React, { useState } from 'react';
import { Box, Typography } from '@mui/material';
import uploadIcon from '../../../../assets/icon/icon-upload.png';
import addBranchesIcon from '../../../../assets/tree/add-branches.svg';
import addBranchesHoverIcon from '../../../../assets/tree/add-branches-hover.svg';
import addChallengeIcon from '../../../../assets/tree/add-challenge.svg';
import {
  ADD_MORE_BRANCHES,
  NEXT_CHALLENGE_ROUTE,
} from '../../../../constants/routes.constants';
import { useHistory } from 'react-router-dom';
import GetVerifiedNowModal from '../../next_challenge/getVerifiedNowModal';
import CreationUpload from '../../upload/CreationUpload';
import TimeToUpgradeModal from '../../onboarding/signup_popups/TimeToUpgradeModal';

const TreeSideButtons = ({ dependent }) => {
  const history = useHistory();
  const [showGetVerifiedNow, setShowGetVerifiedNow] = useState(false);
  const [showUpload, setShowUpload] = useState(false);
  const [showTimeToUpgradePopup, setShowTimeToUpgradePopup] = useState(false);

  const handleCloseUpload = () => setShowUpload(false);

  const handleOnUploadComplete = (creation) => {};

  const handleShowUpload = () => {
    if (dependent && !dependent.profile.is_activated) {
      setShowGetVerifiedNow(true);
    } else {
      setShowUpload(true);
    }
  };

  return (
    <React.Fragment>
      <Box className="tree-add-btns-wrapper">
        <Box
          className="btn-box branch-btn"
          onClick={() =>
            history.push({
              pathname: ADD_MORE_BRANCHES,
              state: {
                from: 'dashboard',
              },
            })
          }
        >
          <Box className="add-branch-text-box">
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Add Branches
            </Typography>
          </Box>
          <Box
            component="img"
            className="normal-img add-btns-icons"
            src={addBranchesIcon}
          />
          <Box
            component="img"
            className="hover-img add-btns-icons"
            src={addBranchesHoverIcon}
          />
        </Box>
        <Box
          className="btn-box challenge-btn"
          onClick={() => history.push(NEXT_CHALLENGE_ROUTE)}
        >
          <Box className="add-challenge-text-box">
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Add Challenges
            </Typography>
          </Box>
          <Box
            component="img"
            className="add-btns-icons"
            src={addChallengeIcon}
          />
        </Box>
        <Box className="btn-box creation-btn" onClick={handleShowUpload}>
          <Box className="add-creation-text-box">
            <Typography variant="body2" sx={{ fontWeight: 600 }}>
              Add Creations
            </Typography>
          </Box>
          <Box component="img" className="add-btns-icons" src={uploadIcon} />
        </Box>
      </Box>
      {showGetVerifiedNow && (
        <GetVerifiedNowModal
          show={showGetVerifiedNow}
          setShow={setShowGetVerifiedNow}
        />
      )}
      <CreationUpload
        from="myroom"
        showUpload={showUpload}
        handleClose={handleCloseUpload}
        handleOnUploadComplete={handleOnUploadComplete}
        setShowTimeToUpgradePopup={setShowTimeToUpgradePopup}
      />
      {showTimeToUpgradePopup && (
        <TimeToUpgradeModal
          showPopup={showTimeToUpgradePopup}
          setShowPopup={setShowTimeToUpgradePopup}
          upgradeType="creation"
        />
      )}
    </React.Fragment>
  );
};

export default TreeSideButtons;
